<template>
    <div class="up-for-date mt-4 mx-5 fs-14px">
        <div class="d-flex">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Tài khoản có:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'ml-3': $detect == 'mobile'
            }">
                <span class="mb-0"><span class="text-danger fw-600">{{money.money_text}}</span> {{money.unit}}</span>
                <span class="ml-3"><a href="https://vatgia.com/nap-tien.html" class="btn-recharge">Nạp {{money.unit}}</a></span>
            </div>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': true
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Số tiền thiết lập {{product.length > 1 ? 'mỗi tin' : ''}}:</div>
            <div :class="{
                    'w-70': $detect == 'web',
                }">
               <!--  <input type="text" inputmode="numeric" class="input-number-up" v-model="count"
                    @input="calculateTotal" @focus="(e) => e.target.select()"/>
                {{config.con_product_auto_up_price ? config.con_product_auto_up_price.unit : ''}}
                <span class="mx-1" v-if="product.length > 1">x {{product.length}} tin</span>
                <span class="mx-1">=</span> -->
                <input type="text" inputmode="numeric" class="input-price-up ml-1" v-model="total"
                    @input="calculateCount" @focus="(e) => e.target.select()"/> {{money.unit}}
                
            </div>
        </div>
        <div class="mt-2 d-flex">
            <p class="mb-0 text-secondary fs-12px mt-2">* Gian hàng nên thiết lập hạn mức số tiền đấu giá tối thiểu là 500.000đ để quảng cáo tối ưu</p>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex' : $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30 lh-48': $detect == 'web'
                }">Ngày bắt đầu:</div>
            <div :class="{
                'w-70': $detect == 'web'
            }">
                <div class="content-change-time mt-2">
                    <div :class="{'d-flex' : true, 'justify-content-between' : $detect == 'mobile'}">
                        <div :class="{
                                'fw-600' : true,
                                'mr-3'   : $detect == 'web'
                            }">
                          <input type="date" class="date-change" v-model="startDate"
                                :min="dayNow"/>
                        </div>
                        <div>
                            <ldc-time placeholder="HH:mm"
                                :showSeconds="false"
                                :jumpMinutes="5"
                                titleMobile="Thời gian"
                                v-model="startTime"
                                class="time-change"/>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div :class="{
            'mt-4': true,
            'd-flex' : $detect == 'web'
        }">
        <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30 lh-48': $detect == 'web'
                }">Ngày kết thúc:</div>
            <div :class="{
                'w-70': $detect == 'web'
            }">
                <div class="content-change-time mt-2">
                    <div :class="{'d-flex' : true, 'justify-content-between' : $detect == 'mobile'}">
                        <div :class="{
                                'fw-600' : true,
                                'mr-3'   : $detect == 'web'
                            }">
                          <input type="date" class="date-change" v-model="endDate"
                                :min="dayNow"/>
                        </div>
                        <div>
                            <ldc-time placeholder="HH:mm"
                                :showSeconds="false"
                                :jumpMinutes="5"
                                titleMobile="Thời gian"
                                v-model="endTime"
                                class="time-change"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Tự động gia hạn:</div>
            <div :class="{
                    'w-70': $detect == 'web',
                }">
                <div :class="{
                            'd-flex': true,
                            'mt-1 justify-content-around': $detect == 'mobile',
                        }">
                        <div :class="{
                                'custom-control custom-radio': true,
                                'custom-control-inline mr-5': $detect == 'web'
                            }">
                            <input type="radio"
                                id="autoRadioInline1"
                                name="auto"
                                class="custom-control-input"
                                v-model="auto" :value="1">
                            <label class="custom-control-label"
                                for="autoRadioInline1">
                               Có
                            </label>
                        </div>
                        <div :class="{
                                'custom-control custom-radio': true,
                                'custom-control-inline ml-5 mr-0': $detect == 'web'
                            }">
                            <input type="radio"
                                id="khong"
                                name="auto"
                                class="custom-control-input"
                                v-model="auto" :value="0">
                            <label class="custom-control-label"
                                for="khong">
                                Không
                            </label>
                        </div>
                    </div>
            </div>
        </div>
        <div :class="{
                'select-up-detail mt-4':true,
                }">
            <div :class="{
                        'mb-0 fs-14px fw-600 mb-2 position-relative title-dg' : true,
                        'w-30' : $detect == 'web'
                        }">Chọn mức đấu giá: 
                <div class="dg-money position-absolute border" @click="btnSelect">
                    {{ selected != '' ? $formatNumber(selected) : '?' }}
                </div>
                <p class="position-absolute select-dg" @click="btnSelect">Chọn</p>
            </div> 
            <transition name="fade">
                 <div class="box" v-show="showData && $detect == 'mobile'">
                    <ldc-select-show-option
                        class="price"
                        v-model="selected"
                        :showPlaceholder="false">
                            <ldc-option-show
                                v-for="(row, index) in optionPrice" :key="index"
                                :value="row.price"
                                :label="$formatNumber(row.price)"/>
                    </ldc-select-show-option>
                </div>
            </transition>
        </div>
        <div :class="{
                'select-up-detail mt-4':true,
                }">
            <transition name="fade">
                <div class="box" v-show="showData && $detect == 'web'">
                    <ldc-select-show-option
                        class="price"
                        v-model="selected"
                        :showPlaceholder="false">
                            <ldc-option-show
                                v-for="(row, index) in optionPrice" :key="index"
                                :value="row.price"
                                :label="$formatNumber(row.price)"/>
                    </ldc-select-show-option>
                </div>
            </transition>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Áp dụng cho toàn bộ danh mục {{ catName }} :</div>
            <div :class="{
                    'w-70': $detect == 'web',
                }">
                <div :class="{
                            'd-flex': true,
                           
                            'mt-1 justify-content-around': $detect == 'mobile',
                        }">
                        <div :class="{
                                'custom-control custom-radio': true,
                                'custom-control-inline mr-5': $detect == 'web'
                            }">
                            <input type="radio"
                                id="applyCategory1"
                                name="applyCategory"
                                class="custom-control-input"
                                v-model="applyCategory" :value="1">
                            <label class="custom-control-label"
                                for="applyCategory1">
                               Có
                            </label>
                        </div>
                        <div :class="{
                                'custom-control custom-radio': true,
                                'custom-control-inline ml-5 mr-0': $detect == 'web'
                            }">
                            <input type="radio"
                                id="applyCategory2"
                                name="applyCategory"
                                class="custom-control-input"
                                v-model="applyCategory" :value="0">
                            <label class="custom-control-label"
                                for="applyCategory2">
                                Không
                            </label>
                        </div>
                    </div>
            </div>
        </div>
        <div class="mt-5 mt-mobile">
            <p class="text-center mb-0 text-danger mb-2 fs-14px" v-if="count > 1000">Quá 1000 lần up. Vui lòng điều chỉnh lại</p>
            <p class="text-center mb-0 text-danger mb-2 fs-14px"
                v-else-if="total > money.money">
                Quá số điểm trong tài khoản, Vui lòng nạp thêm {{money.unit}}
            </p>
            <div class="btn-confirm mb-3">
                <button class="btn btn-primary mx-auto py-1"
                    :disabled="count <= 0 || loading || count > 1000" @click="submit()">
                    Thực hiện
                </button>
            </div>
        </div>

    </div>
</template>
<script>
import { getMinutes, getDayInWeek } from '@/config/function';
export default {
    props: ['product', 'price'],
    data() {
        return {
            day: [
                {
                    value: 'T2',
                    label: 'Thứ 2'
                },
                {
                    value: 'T3',
                    label: 'Thứ 3'
                },
                {
                    value: 'T4',
                    label: 'Thứ 4'
                },
                {
                    value: 'T5',
                    label: 'Thứ 5'
                },
                {
                    value: 'T6',
                    label: 'Thứ 6'
                },
                {
                    value: 'T7',
                    label: 'Thứ 7'
                },
                {
                    value: 'CN',
                    label: 'Chủ Nhật'
                },
            ],
            inputTime: false,
            valueDays: [],
            sortDays: [],
            count: 1,
            total: 0,
            timeAutos: [''],
            loading: false,
            allDay: false,
            dayNow : '',
            classify : '',
            date: '',
            timeUpdate : '',
            startDate : '',
            startTime : '08:00',
            endDate : '',
            endTime : '23:55',
            selected : '',
            optionPrice : [],
            showData : false,
            lastScrollTop : 0,
            auto : 1,
            catName : '',
            applyCategory: 1,
            ppcCostMin : 0,
            convertPpcCostMin : '',
            convertPpcCostMax : '',
            ppc_cost_max : 0,

        }
    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    created() {
        this.total = formatNumber(this.price)
        this.updateUp();
        this.loadDataProductToTitan();
    },
    mounted(){
        this.valueDays = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
    },
    watch: {
        selected(){
            this.showData = false;
        },
        valueDays(val) {
            let sort = [...val];
            let oldSortDays = [...this.sortDays];
            this.sortDays = [];
            let check = null;
            if(val.length == 7){
                this.allDay = true;
            }else{
                this.allDay = false;
            }
            sort.sort().map(item => {
                check = this.checkOld(oldSortDays, item);
                if(check !== null){
                    this.sortDays.push(check)
                }else{
                    this.sortDays.push({
                        day: item,
                        time: [''],
                    });
                }
            });
        },
        product: {
            handler(val){
                this.calculateCount();
            },
            deep: true,
        },
        price(val){
            this.total = formatNumber(val);
        },
        total(val){
            this.$emit('update:price', stringToNumber(val));
            // this.calculateCount();
        },
    },
    methods: {
        btnSelect(){
            this.showData = !this.showData;
        },
        updateUp(){
            let day = new Date();
            let dayNow = day.getDate() < 10 ? '0'+day.getDate() : day.getDate();
            let m = day.getMonth() + 1 < 10 ? '0'+(day.getMonth()+1) : day.getMonth() + 1;
            this.dayNow = day.getFullYear() + '-' + m + '-' + dayNow;
            this.endDate = this.dayNow;
            this.startDate =  this.dayNow;
            // this.changeTime = true;
            // let date = item.schedule.split(' ');
            // this.timeUpdate = date[1];
            // date = date[0].split('/');
            // this.date = date[2] + '-' + date[1] + '-' + date[0];
            // this.date = checkDateInput(this.date);
            // this.id = item.id;
            // this.indexUpdate = index;
        },
        loadDataProductToTitan(){
            let params = {
                iData : this.$route.query.id
            };
            apiGet(`/v2/products/load_add_product_to_titan`,params).then(res => {
                this.optionPrice = res.data.arrCostOption;
                this.catName    = res.data.cat_name;
                this.convertPpcCostMin = res.data.convert_ppc_cost_min;
                this.ppcCostMin = res.data.ppc_cost_min;
                // this.userMoney  = res.data.user_money;
                // this.convertUserMoney  = res.data.convert_user_money;
                // if(res.data.max_amount != 0) this.price =res.data.max_amount; 
                this.selected =res.data.put_ppc_cost;
                // this.auto = res.data.auto_renew; 
                if(res.data.from_date != '') this.startDate = res.data.from_date;
                if(res.data.from_time != '') this.startTime = res.data.from_time;
                if(res.data.to_date != '') this.endDate = res.data.to_date;
                if(res.data.to_time != '') this.endTime = res.data.to_time;
                this.ppc_cost_max  = res.data.ppc_cost_max;
                this.convertPpcCostMax = res.data.convert_ppc_cost_max;
                // this.price_nomal        =   res.data.convert_price_nomal;
                // this.$emit('changes',res.message, res.success);
                
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    this.$router.push({
                        name: 'product',
                        query: ''
                    })
                 }
            })
        },
        changeAllDay(){
            if(this.allDay){
                this.valueDays = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
            }else{
                this.valueDays = [];
            }
        },
        calculateTotal(){
            let check = stringToNumber(this.count);
            if(check > 0 && check <= 10000){
                this.count = formatNumber(check);
            }else{
                if(check <= 0){
                    this.count = '1';
                }else{
                    this.count = formatNumber(10000);
                }
            }
            this.total = formatNumber(this.product.length * stringToNumber(this.count) * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true)));
        },
        calculateCount(){
            let check = stringToNumber(this.total);
            if(check >= 0 &&  check <= 10000 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true))){
                this.count = formatNumber(Math.floor(stringToNumber(this.total) / (this.product.length * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true)))))
                this.total = formatNumber(check);
            }else{
                if(check < 0){
                    this.count = '1';
                    this.total = 1 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true));
                }else{
                    this.total = formatNumber(10000 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true)) * this.product.length);
                    this.count = formatNumber(10000)
                }
            }
        },
        reset(){
            this.valueDays = [];
            this.count = 1;
            this.timeAutos = [''];
            this.inputTime = false;
            this.calculateTotal();
            this.allDay = false;
        },
        checkOld(oldSortDays, day){
            let check = null;
            oldSortDays.map((item, index) => {
                if(item.day === day){
                    check = item;
                }
            });
            return check;
        },
        removeTime(key, index = null){
            if(this.inputTime){
                if(this.sortDays[key].time.length > 1){
                    this.sortDays[key].time.splice(index, 1);
                }
            } else {
                if(this.timeAutos.length > 1){
                    this.timeAutos.splice(key, 1);
                }
            }
        },
        async submit(){
            let form = {
                    'time_start' : this.startTime,
                    'time_end' : this.endTime,
                    'end_day' : this.endDate,
                    'start_day' : this.startDate,
                    'max_price' : this.$stringToNumber(this.total),
                    'auto'      : this.auto,
                    'put_ppc_cost' : this.selected,
                    'apply_category' : this.applyCategory,
                    'id'                : this.$route.query.id,
                    'ppc_auction'       : 1,
                    'action'            : 'execute',
                }
                this.loading = true
            if(this.checkform()){
                apiPost(`/v2/products/add_product_to_titan`,form).then(res => {
                    if(res.success == 1){
                        this.$message({
                            message: res.message,
                            type: 'success',
                            center: true,
                        })
                        setTimeout(() => {
                            location.reload();
                        }, 200);
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error',
                            center: true,
                        })
                    }
                }).catch(err => {
                    this.$message({
                        message: 'Lỗi hệ thống',
                        type: 'error',
                        center: true,
                    });
                })
                getMoney();
            }
            this.loading = false;
        },
        checkform(){
            if(this.selected == 0){
                // this.errors.dg = true;
                let message = 'Bạn chưa chọn mức đấu giá';
                this.messages(message);
                return false;
            }
            if(this.total == 0 || this.total > this.$store.state.money.money){
                // this.errors.tl = true;
                let message = 'Bạn chưa nhập số tiền thiết lập tối đa <br> Hoặc số tiền thiết lập tối đa nhiều hơn số tiền hiện có trong tài khoản của bạn';
                this.messages(message);
                return false;
            }
            if(this.selected <= this.ppcCostMin){
                // this.errors.dg = true;
                let message = 'Giá của bạn phải lớn hơn giá sàn ' + this.convertPpcCostMin;
                this.messages(message);
                return false;
            }
            if(this.selected > this.ppc_cost_max){
                // this.errors.dg = true;
                let message = 'Giá của bạn phải nhỏ hơn hoặc bằng ' + this.convertPpcCostMax;
                this.messages(message);
                return false;
            }
            if(parseInt(this.dayNow.replace(/-/g,""),10) > parseInt(this.startDate.replace(/-/g,""),10)){
                 // this.errors.dg = true;
                let message = 'Bạn hãy thiết lập ngày tháng!'
                this.messages(message);
                return false;
            }
            if(parseInt(this.startDate.replace(/-/g,""),10) > parseInt(this.endDate.replace(/-/g,""),10)){
                 // this.errors.dg = true;
                let message = 'Hãy xem lại ngày tháng!'
                this.messages(message);
                return false;
            }
            return true;
        },
        messages(mes){
            this.$message({
                message: mes,
                type: 'error',
                center: true,
            });
        },
    }
}
</script>
<style lang="scss">
        .fade-enter-active, .fade-leave-active {
          transition: opacity .5s;
        }
        .fade-enter, .fade-leave-to {
          opacity: 0;
        }
        .rv-select-form {
            .ldc-input {
                border: 1px solid rgba(0, 0, 0, 0.2) !important;
                color: #000;
                font-size: 16px !important;
                height: unset !important;
                line-height: unset !important;
                padding: 10px !important;
                border: 1px solid #007bff !important;
            }
        }
        .select-mobile-post {
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            .ldc-placeholder-select-mobile {
                border-radius: 4px;
                i {
                    float: right;
                }
            }
        }
        .text-position-select {
            top: -13px;
            padding: 0 10px;
            background: #fff;
            margin-left: 10px;
        }
    .ppc-pro-web {
        .dg-money {
            color: #dc3545;
            top: -6px;
            right: -82px;
            width: 81.75px;
            height: 37px;
            padding: 8px 0 !important;
            border-radius: 4px !important;
            font-size: 14px !important;
            text-align: center !important;
        }
         .select-dg{
            top: 0px;
            right: -138px;
            text-decoration: underline;
            color: #007bff;
        }
        .select-up-detail {
            .ldc-select-show-option {
                padding: 0 !important;
                .option {
                    padding: 8px 0 !important;
                    border-radius: 4px !important;
                    font-size: 14px !important;
                    text-align: center !important;
                   
                }
                .bg-primary {
                    box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08) !important;
                }
            }
        }
        .lh-48{
            line-height: 48px;
        }
        .time-change .input-time-mobile {
            width: 170px;
            height: 40px;
            border-radius: 4px;
            padding: 5px 10px;
            line-height: 31px;
            text-align: left;
        }
         .date-change {
            height: 40px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            padding: 5px 10px;
            line-height: 21px;
            color: #666;
            width: 170px;
        }
        .up-for-date {
            .w-30 {
                width: 30%;
            }
            .w-70 {
                width: 70%;
                .input-number-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 50px;
                    border-radius: 0 !important;
                    &:focus {
                        outline: none;
                    }
                }
                .text-warning-up {
                    color: rgba(0, 0, 0, 0.5);
                }
                .input-timedate-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 50px;
                }
                .btn-add-time {
                    padding: 2px 15px;
                    font-size: 14px;
                    display: inline-block;
                    height: 30px;
                    margin-top: -3px;
                }
                .btn-recharge {
                    text-decoration: underline;
                }
                .ldc-time {
                    display: inline-block;
                    input {
                        width: 170px;
                        height: 40px;
                    }
                }
                .time-up-detail {
                    .custom-control-label {
                        padding-top: 2px;
                    }
                    .col-time-auto {
                        .col-stt {
                            width: 30px;
                            padding-top: 3px;
                        }
                        .col-time {
                            .btn-delete-time {
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                    .flex-time {
                        width: calc(100% - 10px);
                    }
                    .btn-delete-time {
                        z-index: 1000;
                        top: 4px;
                        right: 0;
                    }
                }
                .input-price-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 75px;
                    border-radius: 0 !important;
                    color: #dc3545;
                    font-weight: 600;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
        .btn-confirm {
            display: flex;
            justify-content: center;
            align-items: center;
            button {
                padding-left: 40px;
                padding-right: 40px;
            }
        }
    }
    .ppc-pro-mobile {
        .title-dg{
            width: max-content;
        }
        .dg-money{
            color:#dc3545;
            top: -6px;
            right: -95px;
            width: 81.75px;
            height: 37px;
            padding: 8px 0 !important;
            border-radius: 4px !important;
            font-size: 14px !important;
            text-align: center !important;
        }
        .select-dg{
            top: 0px;
            right: -138px;
            text-decoration: underline;
            color: #007bff;
        }
        .select-mobile-post{
            .ldc-placeholder-select-mobile{
                width: 170px;
                height: 40px;
            }
        }
        .date-change {
            height: 40px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            padding: 5px 10px;
            line-height: 21px;
            color: #666;
            width: 170px;
        }
        .time-change .input-time-mobile {
            width: 170px;
            height: 40px;
            border-radius: 4px;
            padding: 5px 10px;
            line-height: 31px;
            text-align: left;
        }
        .up-for-date {
            margin: 24px 0 0 0 !important;
            .w-30 {
                width: 40%;
                font-size: 14px;
            }
            .w-70 {
                width: 60%;
                font-size: 14px;
                .text-warning-up {
                    color: rgba(0, 0, 0, 0.5);
                }
                .input-timedate-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 50px;
                }
                .col-date {
                    width: 25%;
                    margin-top: 5px;
                }
                .max-up-mobile {
                    display: block;
                    margin: 5px 0 0 0 !important;
                }
            }
            .btn-recharge {
                text-decoration: underline;
            }
            .input-number-up {
                border: none;
                border-bottom: 1px solid #000;
                width: 35px;
                border-radius: 0 !important;
            }
            .input-price-up {
                border: none;
                border-bottom: 1px solid #000;
                width: 75px;
                font-weight: 600;
                color: #dc3545;
            }
            .col-time-auto {
                .btn-add-time {
                    width: 35px;
                    height: 35px;
                    font-size: 25px;
                    line-height: 35px;
                    padding: 0;
                }
                .btn-delete-time {
                    z-index: 999;
                    top: 6px;
                    right: 0;
                    width: 30px;
                    height: 30px;
                    padding-left: 10px;
                }
            }
            .select-up-detail {
                .ldc-select-show-option {
                    padding: 0 !important;
                    .option {
                        padding: 8px 0 !important;
                        border-radius: 4px !important;
                        font-size: 14px !important;
                        width: calc( 25% - 8px ) !important;
                        text-align: center !important;
                        &:nth-child(4n+4) {
                            margin-right: 0 !important;
                        }
                    }
                    .bg-primary {
                        box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08) !important;
                    }
                }
            }
        }
        .mt-mobile {
            margin-top: 24px !important;
        }
        .btn-confirm {
            display: flex;
            justify-content: center;
            align-items: center;
            button {
                padding-left: 40px;
                padding-right: 40px;
            }
        }
        .custom-radio {
            font-size: 14px;
        }
    }
</style>
